import axios from 'axios'
import * as R from 'ramda'
import { load_one, load_many, update, _get_counts } from '@/store/action-helpers'
import http from '@/http'
import * as Types from '@/store/mutation-types'

// noinspection JSUnusedGlobalSymbols
export default {

    /**
     * Lädt eine Seite Jobs vom Server (server-seitige Paginierung).
     * - status:     Job-Status-Filter (z.B. 'NEW'); 'ALL' oder undefined = kein Filter
     * - isArchived: true/false; undefined = kein Filter
     * - setCounts:  X-Count-* Header als Tab-Badges in den Store schreiben (default: false)
     * - sort:       Spring-Data-Sort-String, z.B. 'id,desc' (default: 'id,desc')
     * Gibt { jobs, totalElements } zurück.
     */
    async loadPage({ commit }, { page = 0, size = 25, isArchived, status, setCounts = false, sort = 'id,desc' } = {}) {
        const params = { page, size, sort }
        if (isArchived !== undefined) params.isArchived = isArchived
        if (status && status !== 'ALL') params.status = status
        const response = await http({ method: 'GET', url: 'jobs', params })
        const jobs = response.data.content
        commit('SET_MANY', { content: jobs })
        if (setCounts) commit(Types.SET_COUNTS, { content: _get_counts(response.headers) })
        return { jobs, totalElements: response.data.totalElements }
    },

    create({ dispatch }, { model }) {
        // Job speichern
        return axios.post('/api/v1/jobs', model).then(response => {
            return Promise.all([

                // Job laden
                dispatch('loadOne', { id: response.data.id, force: true }),

                // Alle Angebote des Jobs laden
                dispatch('offers/loadAllByJobId', { jobId: response.data.id, force: true }, { root: true }),

                // Alle Preise des Jobs laden
                dispatch('prices/loadAllByJobId', { jobId: response.data.id, force: true }, { root: true })

            ]).then(R.head)
        })
    },

    loadAll: load_many('jobs', { setCounts: true }),
    loadAllByProductId: load_many('products/:productId/jobs'),
    loadOne: load_one('jobs/:id'),
    update: update('jobs/:id'),

}
